import type { MasterDataItem } from "@/lib/types/master-data";

export type {
  Branch,
  MasterData,
  MasterDataApiResponse,
  MasterDataItem,
  PassengerOption,
} from "@/lib/types/master-data";

export const vehicleCategoryIcons: Record<number, string> = {
  1: "bi-car-front",
  2: "bi-truck",
  3: "bi-bus-front",
  4: "bi-truck-flatbed",
  5: "bi-truck",
  6: "bi-truck-front",
};

export const transmissionIcons: Record<number, string> = {
  1: "bi-circle-fill",
  2: "bi-gear",
};

export const fuelTypeIcons: Record<number, string> = {
  1: "bi-fuel-pump",
  2: "bi-fuel-pump-fill",
};

export function buildFuelTypeMap(
  fuelTypes: MasterDataItem[],
): Map<string, string> {
  return new Map(fuelTypes.map((fuel) => [String(fuel.id), fuel.name]));
}

export function buildTransmissionTypeMap(
  transmissions: MasterDataItem[],
): Map<string, string> {
  return new Map(
    transmissions.map((transmission) => [
      String(transmission.id),
      transmission.name,
    ]),
  );
}
